/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { RewardToken } from "../RewardToken";

export class RewardToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    adminOne: string,
    adminTwo: string,
    adminThree: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RewardToken> {
    return super.deploy(
      adminOne,
      adminTwo,
      adminThree,
      overrides || {}
    ) as Promise<RewardToken>;
  }
  getDeployTransaction(
    adminOne: string,
    adminTwo: string,
    adminThree: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      adminOne,
      adminTwo,
      adminThree,
      overrides || {}
    );
  }
  attach(address: string): RewardToken {
    return super.attach(address) as RewardToken;
  }
  connect(signer: Signer): RewardToken__factory {
    return super.connect(signer) as RewardToken__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardToken {
    return new Contract(address, _abi, signerOrProvider) as RewardToken;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "adminOne",
        type: "address",
      },
      {
        internalType: "address",
        name: "adminTwo",
        type: "address",
      },
      {
        internalType: "address",
        name: "adminThree",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "minterAddress",
        type: "address",
      },
    ],
    name: "approveMinterRemoval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "proposedMinterAddress",
        type: "address",
      },
    ],
    name: "approveProposedMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "giveMintingConsent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "proposedMinterAddress",
        type: "address",
      },
    ],
    name: "proposeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "minterAddress",
        type: "address",
      },
    ],
    name: "proposeMinterRemoval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "removeMintingConsent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
